import { createFileRoute } from "@tanstack/react-router";
import { parseCustomersListSearch } from "@/features/customers/schemas";

export const Route = createFileRoute("/_app/customers/")({
  validateSearch: parseCustomersListSearch,
});
